import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import VideoPlayer from "../../components/player";
import { getCourseById } from "../../services/courseService";
import { SFContentContainer, SFProgressBar } from "@sf-core";
import { Logger } from "@base-provider";
import { useNavigate } from "react-router-dom";
import { launchPadLayoutActions } from "../../redux/reducers/layoutReducer";

const CourseScreen = () => {
  const [prvLoc, setPrvLoc] = useState(null);
  const location = useLocation();
  let { id } = useParams();
  id = id.toLowerCase();
  let navigate = useNavigate();
  const [course, setCourse] = useState({ loading: true });
  const dispatch = useDispatch();

  useEffect(() => {
    setPrvLoc(location.state?.previousLoc ?? -1);
  }, []);

  useEffect(() => {
    dispatch(launchPadLayoutActions.setState({ showLoader: true }));
    // When the user enters the course player, the updates on demand interval change to Default(30s)
    dispatch(launchPadLayoutActions.setState({ updatesOnDemandInterval: false }));
    getCourseById(id).then((response) => {
      Logger.of("App.CourseScreen.then").info({ response });
      setCourse(response.data);
    });
  }, [id]);

  Logger.of("App.CourseScreen").info({ id, course });

  return (
    <SFContentContainer disableGutters>
      {!course || course.loading ? (
        <SFProgressBar narrow variant="indeterminate" />
      ) : (
        <VideoPlayer
          course={course}
          onClose={() => {
            // When the user exits the course player, the updates on demand interval change to On Demand(1s) for the next minute
            dispatch(launchPadLayoutActions.setState({ updatesOnDemandInterval: true }));
            navigate(prvLoc);
          }}
        />
      )}
    </SFContentContainer>
  );
};

export default CourseScreen;
